<template>
    <div
        v-if="shouldShow"
        class="bg-black-80 full-width relative tabletLandscape:h-auto flex flex-col">
        <form
            class="container max-w-3xl flex flex-col items-center z-10 pt-8 tablet:pt-16 pb-16"
            @submit.prevent="submit">
            <div class="phone:text-2xl text-3xl font-light text-white tracking-widest uppercase text-center tablet:-mt-3">
                <h2
                    class="font-bold"
                    v-html="content.primaryLine" />
                <h3
                    class="phone:text-xl text-2xl my-6"
                    v-html="content.secondaryLine" />
            </div>
            <div class="min-w-sm flex flex-col gap-6">
                <TisInput
                    id="join-us-email"
                    v-model.trim="email"
                    :placeholder="content.inputPlaceholder"
                    name="email"
                    type="email"
                    class="w-full"
                    required
                />
                <button
                    type="submit"
                    class="btn-gold-tight w-full cursor-pointer disable-reset disabled:bg-gold-700"
                    :disabled="submitDisabled"
                    v-text="content.submitLabel"
                />
            </div>
            <div class="text-center text-sm mt-8">
                <p
                    v-for="term in content.terms"
                    :key="term"
                    v-html="term" />
            </div>
        </form>
    </div>
</template>

<script>
import TisInput from '@whisper/components/forms/Primitives/TisInput';

export default {
  name: 'SectionJoinUs',
  components: {
    TisInput,
  },
  data() {
    return {
      email: '',
      submitDisabled: false,
    };
  },
  computed: {
    shouldShow() {
      const content = this.content || {};
      return content.show && !this.isLoggedIn;
    },
    content() {
      return this.$page.sectionJoinUs;
    },
    isLoggedIn() {
      const { clientLogoutLabel } = this.$page.menu;

      return Boolean(clientLogoutLabel);
    },
  },
  methods: {
    async submit() {
      this.submitDisabled = true;
      await this.$inertia.post(this.content.submitUrl, { email: this.email });
      this.submitDisabled = false;
    },
  },
};
</script>

<style scoped>
.disable-reset:disabled {
    background-image: none;
    cursor: not-allowed;
}
.disable-reset:disabled:hover {
    background-image: none;
}
</style>
